import { AxiosHttpPostFile } from 'axios-http';
import { SPARE_PARTS } from 'resources/links';

export function getReportFile(DateEnd: any, DateStart: any, Type: any) {
    let body = { DateEnd, DateStart, Type };
    return AxiosHttpPostFile({ url: SPARE_PARTS.getReport, data: body });
}
